export const partyMembers = [
  {
    id: "valerie",
    name: "Valerie Shockwind",
    player: "Tom Barnard (creator of the site)",
    bio: "Gay dragon girl my beloved. Wields a staff of frost, and is a big fan of Scorching Ray. And Women.",
    image: "/characters/valerie.jpg",
    playlistUrl: "https://open.spotify.com/playlist/1OhwBc99qmLTkoX4T83BMv?si=ccee26886aed4637",
  },
  {
    id: "leofir",
    name: "Leofir Cedarhold",
    player: "Wesley Fido",
    bio: "A drow cleric, except he has standard human skin colour and only ever uses damaging spells. Will probably use 2 healing spells all campaign.",
    image: "/characters/leofir.jpg",
    playlistUrl: "",
  },
  {
    id: "mouven",
    name: "Mouven Ironwill",
    player: "Olivia Dolan",
    bio: "Our ruthless minotaur. Lover of two things. His husband Bangbore and weapons.",
    image: "/characters/mouven.jpg",
    playlistUrl: "",
  },
  {
    id: "thorne",
    name: "Thorne Bell",
    player: "Jessica Lodge",
    bio: "The plant and animal loving Druid. She does all the healing. But she's not a healer, she's a druid. Try telling Wes that.",
    image: "/characters/thorne.jpg",
    playlistUrl: "",
  },
  {
    id: "zenash",
    name: "Zenash",
    player: "Matthew Shaw",
    bio: "Matt's 3rd character, an Orc barbarian. He will stick with one eventually....",
    image: "/characters/zenash.jpg",
    playlistUrl: "",
  },
  {
    id: "bangbore",
    name: "Bangbore Ironwill",
    player: "Joshua Wilmott",
    bio: "A Bridge Troll Sorcerer played by our glorious DM from behind the screen.",
    image: "/characters/bangbore.jpg",
    playlistUrl: "",
  },
]; 